import PropTypes from 'prop-types';
import {Segment} from 'semantic-ui-react';
import {includes, isEmpty} from 'lodash';
import ComparablePropertyAccordionContainer from './ComparablePropertyAccordion';

export default function ComparablePropertyResults(props) {
  const {settings, active, comparables: {fetching, selected = [], suggested, comparableType}} = props;
  return isEmpty(suggested) && !fetching ? (
    <Segment content="Unfortunately, no results were found. Please adjust the filters to expand your search."/>
  ) : (
    <div className="comparable-search-result">
      {suggested
        .filter((propertyId) => !includes(selected, propertyId))
        .map((propertyId) => (
        <ComparablePropertyAccordionContainer
            key={propertyId}
            propertyId={propertyId}
            active={active}
            settings={settings}
            selected={includes(selected, propertyId)}
            comparableType={comparableType}
        />
        ))}
    </div>
  );
}

ComparablePropertyResults.propTypes = {
  comparables: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  active: PropTypes.bool.isRequired,
  featureFlags: PropTypes.shape({})
};
